import React, { useState } from 'react';
import axios from 'axios'; // Import axios for making HTTP requests
import './AddmakeForm.css'
import { IoMdRemoveCircleOutline } from "react-icons/io";
import { IoMdAddCircleOutline } from "react-icons/io";
const AddMakeForm = () => {
  const [manufacturer, setManufacturer] = useState('');
  const [models, setModels] = useState([{ model: '', variants: [''] }]);

  // Handle adding a new model
  const handleAddModel = () => {
    setModels([...models, { model: '', variants: [''] }]);
  };

  // Handle model input changes
  const handleModelChange = (index, value) => {
    const updatedModels = models.map((m, i) =>
      i === index ? { ...m, model: value } : m
    );
    setModels(updatedModels);
  };

  // Handle adding a new variant to a model
  const handleAddVariant = (modelIndex) => {
    const updatedModels = models.map((m, i) =>
      i === modelIndex ? { ...m, variants: [...m.variants, ''] } : m
    );
    setModels(updatedModels);
  };

  // Handle variant input changes
  const handleVariantChange = (modelIndex, variantIndex, value) => {
    const updatedModels = models.map((m, i) =>
      i === modelIndex
        ? {
            ...m,
            variants: m.variants.map((v, vi) =>
              vi === variantIndex ? value : v
            ),
          }
        : m
    );
    setModels(updatedModels);
  };

  // Handle removing a model
  const handleRemoveModel = (index) => {
    setModels(models.filter((_, i) => i !== index));
  };

  // Handle removing a variant
  const handleRemoveVariant = (modelIndex, variantIndex) => {
    const updatedModels = models.map((m, i) =>
      i === modelIndex
        ? { ...m, variants: m.variants.filter((_, vi) => vi !== variantIndex) }
        : m
    );
    setModels(updatedModels);
  };

  // Handle form submission
  const handleSubmit = async (e) => {
    e.preventDefault();
    
    const makeData = {
      manufacturer,
      models,
    };

    try {
      const response = await axios.post('https://zoomautos.co.uk/api/make', makeData); // Update the URL as necessary

      if (response.status === 201) {
        console.log('Make added successfully');
        // Optionally clear the form or show a success message
        setManufacturer('');
        setModels([{ model: '', variants: [''] }]); // Reset form
      } else {
        console.error('Error adding make');
      }
    } catch (error) {
      console.error('Error during submission:', error);
    }
  };

  return (
    <div className="makeform-container" style={{marginTop:'200px'}}>
      <h2>Add Manufacturer, Models, and Variants</h2>
      <form onSubmit={handleSubmit}>
        <div className="makeform-group">
          <label>Manufacturer</label>
          <input
            type="text"
            value={manufacturer}
            onChange={(e) => setManufacturer(e.target.value)}
            required
            style={{width:'50%'}}
            
          />
        </div>

        {models.map((model, modelIndex) => (
          <div key={modelIndex} className="model-container">
            <div className="makeform-group">
              <label
              
              >Model</label>
              <input
                type="text"
                value={model.model}
                onChange={(e) => handleModelChange(modelIndex, e.target.value)}
                required
                
              />
              <button type="button" onClick={() => handleRemoveModel(modelIndex)} className='addbut'>
              <IoMdRemoveCircleOutline/>
              </button>
            </div>

            {model.variants.map((variant, variantIndex) => (
              <div key={variantIndex} className="variant-container">
                <div className="makeform-group">
                  <label
                  >Variant</label>
                  <input
                    type="text"
                    value={variant}
                    onChange={(e) =>
                      handleVariantChange(modelIndex, variantIndex, e.target.value)
                    }
                    required
                    
                  />
                  <button
                    type="button"
                    onClick={() => handleRemoveVariant(modelIndex, variantIndex)}
                    className='addbut'
                  >
                    <IoMdRemoveCircleOutline/>

                  </button>
                </div>
              </div>
            ))}

            <button
              type="button"
              onClick={() => handleAddVariant(modelIndex)}
              className="addbut"
              style={{marginLeft:'320px'}}
            >
              <IoMdAddCircleOutline/>
            </button>
          </div>
        ))}

        <button type="button" onClick={handleAddModel} className="btn" >
          Add Model
        </button>

        <button type="submit" className="btn">Submit</button>
      </form>
    </div>
  );
};

export default AddMakeForm;
